import React, { useEffect, useState } from "react";
import { Button, Col, Dropdown, DropdownButton, Row, Table, Form } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import HeaderComponent from "./HeaderComponent";
import { FETCH_USERMANUAL_DATA,DOWNLOAD_USER_MANUAL } from "../../constant/Constants";
import { fetchAPIData, isLoggedIn, notAuthorized,UserManualDownload } from "../../api/AuthService";
import { saveAs } from "file-saver"


const NewUpdates = (props) => {
  const navigate = useNavigate()
  const role = localStorage.getItem("role") ? localStorage.getItem("role") : "PG";
  const [whatsNewData, setWhatsNewData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingIdx, setDownloadingIdx] = useState(null); 
  const [errorFlag,setErrorFlag]= useState()

  const downloadGenDocFiles = (fileName, idx) => {
    let filename = "download";
    setDownloadingIdx(idx); 
    UserManualDownload(`${DOWNLOAD_USER_MANUAL}?fileName=${fileName}`)
      .then((response) => {
        if (
          response.headers["filename"] != null &&
          response.headers["filename"] !== ""
        ) {
          filename = response.headers["filename"];
        }
        const fileContents = new Blob([response.data]);
        saveAs(fileContents, filename);
        setDownloadingIdx(null); 
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          alert("The file is not yet available for download.");
        } else if (error.response && error.response.status === 403) {
          alert("Integration service issue. Please contact SpecReaderExt.im@pg.com for help.");
        } else {
          alert("Integration service issue. Please contact SpecReaderExt.im@pg.com for help.");
        }
        setDownloadingIdx(null); 
      });
  };

  const fetchData = async () => {
    try {
      const UserManualData = await fetchAPIData(`${FETCH_USERMANUAL_DATA}?userRole=${role}`);
      if (UserManualData.data && UserManualData.data != null) {
        setWhatsNewData(UserManualData.data);
        setLoading(false);
        setErrorFlag(0)
      } else {
        setErrorFlag(0)
        setLoading(false);
      }
    } catch (error) {
      if (error.response ) {
          setErrorFlag(1)
          
        }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isLoggedIn()) {
         navigate("/")
      }
      else{
        fetchData();
      }
    
  }, [navigate]);

  return (
    <div style={{ width: "100%", minHeight: "100vh", background: "#f4f6fa" }}>
      <HeaderComponent />
      <div style={{ padding: "32px" }}>
        <div
          style={{
            width: "100%",
            color: "#0173d4",
            padding: "20px 0",
            textAlign: "center",
            fontSize: "24px",
            fontWeight: "700",
          }}
        >
          User Guide
        </div>
        <Table className="table table-bordered user-guide-table">
          <thead >
            <tr style={{ height: "25px", alignItems: "center" }}>
              <th>Feature Name</th>
              <th>Updated Date</th>
              <th>File Download</th>
            </tr>
          </thead>
          <tbody>
           { loading  &&  (
              <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>Loading...</td>
              </tr>
            )}
            
            {
              whatsNewData.length === 0 && errorFlag ==0 && (
              <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>No data available</td>
              </tr>
            ) 
            }
            {
              whatsNewData.length === 0 && errorFlag ==1 && (
              <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>Integration service issue. Please contact SpecReaderExt.im@pg.com for help.</td>
              </tr>
            ) 
            }

            { errorFlag ==0 &&  whatsNewData.length !== 0 &&
              (
              whatsNewData.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.featureName}</td>
                  <td>{row.updatedAt}</td>
                  <td style={{textAlign:"center"}} >
                    <Button
                      variant="link"
                      onClick={() => downloadGenDocFiles(row["fileName"], idx)}
                      disabled={downloadingIdx === idx}
                      
                    >
                      {downloadingIdx === idx ? (
                        <i className="fa fa-spinner fa-spin fa-2x" aria-hidden="true" style={{textAlign: "center"}}></i>
                      ) : (
                        <i className="fa fa-download fa-2x" aria-hidden="true" style={{alignItems: "center"}}></i>
                      )}
                    </Button>
                  </td>
                </tr>
              ))
            )
            }
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default NewUpdates;